module.exports = __webpack_public_path__ + "508e035497a85eb99e531caf98b858ad.png";